import React, { Component, Fragment } from "react";
import { ShoppingBag } from "react-feather";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

export class Notification extends Component {
  render() {
    const pending = this.props.pendingOrders.length;
    const unverified = this.props.unverifiedPayments.length;
    return (
      <Fragment>
        <ul className="notification-dropdown onhover-show-div p-0 kd-pop-menu">
          <li className="kd-pop-head">
            <span>Notifications</span>
            <span className="kd-pop-count">{this.props.totalNotificationCount || 0}</span>
          </li>
          <li>
            <Link to="/sales/order_pending" className="kd-pop-item">
              <span className="sb-tile sb-tile--lilac" aria-hidden="true">
                <ShoppingBag size={16} />
              </span>
              <span>
                <strong>Pending orders</strong>
                <small>
                  {pending === 0
                    ? "Nothing waiting right now."
                    : `${pending} ${pending === 1 ? "order is" : "orders are"} waiting.`}
                </small>
              </span>
            </Link>
          </li>
          <li>
            <Link to="/payments/unVerified" className="kd-pop-item">
              <span className="sb-tile sb-tile--mint" aria-hidden="true">
                <strong className="kd-taka-tile">৳</strong>
              </span>
              <span>
                <strong>Unverified payments</strong>
                <small>
                  {unverified === 0
                    ? "All payments are checked."
                    : `${unverified} ${unverified === 1 ? "payment needs" : "payments need"} a review.`}
                </small>
              </span>
            </Link>
          </li>
        </ul>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const unVerifiedPaymentsArray = [];
  state.payments.payments.forEach((payment) => {
    payment.payments.forEach((inPayment) => {
      if (inPayment.paymentStatus === "unVerified") {
        unVerifiedPaymentsArray.push(inPayment);
      }
    });
  });
  return {
    pendingOrders: state.orders.orders.filter(
      (order) => order.status === "order_pending"
    ),
    unverifiedPayments: unVerifiedPaymentsArray,
  };
};
export default connect(mapStateToProps)(Notification);
